import { ComponentProps } from 'react';

import { H1, P2 } from '@/lib/shared/components/Typography';

import { clsx } from 'clsx';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';

import styles from './CompanyBenefits.module.scss';
import {
  apartmentsLandingBenefits,
  benefits,
  propertymanagement,
  rentLanding,
  villaLandingBenefits,
} from './constants';

interface ICompanyBenefits {
  disableBackground?: boolean;
  isVillasLanding?: boolean;
  isApartmentsLanding?: boolean;
  isPropertyManagement?: boolean;
  isRentLanding?: boolean;
  removeLeaf?: boolean;
  className?: string;
  isWideText?: boolean;
  theme?: 'light' | 'dark';
  title?: string;
  TitleTag?: ComponentProps<typeof H1>['as'];
}

export const CompanyBenefits = ({
  disableBackground,
  isVillasLanding,
  isApartmentsLanding,
  isPropertyManagement,
  isRentLanding,
  removeLeaf,
  className,
  isWideText,
  theme = 'dark',
  title = 'benefits',
  TitleTag = 'h2',
}: ICompanyBenefits) => {
  const { t } = useTranslation('index', { keyPrefix: 'about' });

  const items = isVillasLanding
    ? villaLandingBenefits
    : isApartmentsLanding
      ? apartmentsLandingBenefits
      : isPropertyManagement
        ? propertymanagement
        : isRentLanding
          ? rentLanding
          : benefits;

  return (
    <div
      id="benefits"
      className={clsx(
        styles.benefits,
        !disableBackground && styles['benefits--bg'],
        theme === 'light' && styles['benefits--light'],
        isPropertyManagement && styles['benefits--mobGray'],
        isRentLanding && styles['benefits--rent'],
        className
      )}
    >
      {!removeLeaf && (
        <div className={styles.benefits_imageWrapper}>
          <Image
            // sizes="(max-width: 768px) 100vw, 0vw"
            sizes="522px"
            className={styles.benefits_leaf}
            src={'/images/complex/leaf/blue-leaf.webp'}
            fill
            alt=""
          />
        </div>
      )}

      <div className={styles.container}>
        <H1
          as={'h2'}
          className={clsx(
            styles.benefits_title,
            (isPropertyManagement || isRentLanding) &&
              styles['benefits_title--left']
          )}
        >
          {t(title)}
        </H1>
        <ul
          className={clsx(
            styles.benefits_list,
            isVillasLanding && styles['benefits_list--four'],
            isPropertyManagement && styles['benefits_list--smallGap'],
            isRentLanding && styles['benefits_list--three']
          )}
        >
          {items.map((item) => (
            <li
              key={item.title}
              className={clsx(
                styles.benefits_item,
                isWideText && styles['benefits_item--wide'],
                isPropertyManagement && styles['benefits_item--wide--super'],
                isRentLanding && styles['benefits_item--three']
              )}
            >
              <TitleTag
                className={clsx(
                  styles.benefits_item_title,
                  theme === 'light'
                    ? styles['benefits_item_title--light']
                    : styles['benefits_item_title--dark']
                )}
              >
                {t(item.title)}
              </TitleTag>
              <P2>{t(item.text)}</P2>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
